/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2025 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2025 - Finnish Meteorological Institute (FMI)
 * Copyright 2025 - The Norwegian Meteorological Institute (MET Norway)
 * */

export type ColorMap = string[];

export const temperatureLegendColorsWoW: ColorMap = [
  '#2E2E73',
  '#282898',
  '#201FBB',
  '#1A1ADC',
  '#3654DE',
  '#548EDC',
  '#72CADE',
  '#6DD8DF',
  '#55CDE2',
  '#38BBDC',
  '#20B0DC',
  '#19BAA6',
  '#1CCE6A',
  '#1BDF22',
  '#82C319',
  '#DCA819',
  '#DD921A',
  '#DE7C1A',
  '#DF671A',
  '#DE501A',
  '#DD3819',
  '#DD2319',
  '#D21A1E',
  '#C31927',
  '#AD1A30',
  '#9A1A3B',
  '#871A44',
  '#871A44',
];

export const precipitationMMLegendColorsWoW: ColorMap = [
  '#BACDCB',
  '#A3C3C9',
  '#8BBCC8',
  '#6AAEC1',
  '#42A1C0',
  '#377EAF',
  '#46669C',
  '#56528D',
  '#86008D',
  '#610066',
];

export const temperatureLegendColorsCWK: ColorMap = [
  '#BFB1FF',
  '#8E7EE4',
  '#6450CC',
  '#422BB1',
  '#260E99',
  '#B1E4FF',
  '#7EC3E4',
  '#50A3CC',
  '#2B85B1',
  '#0E6B99',
  '#E4FFB1',
  '#C3E47E',
  '#A3CC50',
  '#85B12B',
  '#6B990E',
  '#FFD8B1',
  '#E4B17E',
  '#CC8E50',
  '#B16E2B',
  '#99540E',
  '#FFB1B1',
  '#E47E7E',
  '#CC5050',
  '#B12B2B',
  '#990E0E',
  '#BFB1FF',
  '#8E7EE4',
  '#6450CC',
  '#422BB1',
  '#260E99',
  '#B1E4FF',
  '#7EC3E4',
  '#50A3CC',
  '#2B85B1',
  '#0E6B99',
  '#E4FFB1',
  '#C3E47E',
  '#A3CC50',
  '#85B12B',
  '#6B990E',
  '#FFD8B1',
  '#E4B17E',
  '#CC8E50',
  '#B16E2B',
  '#99540E',
  '#FFB1B1',
  '#E47E7E',
  '#CC5050',
  '#B12B2B',
  '#990E0E',
  '#BFB1FF',
  '#8E7EE4',
  '#6450CC',
  '#422BB1',
  '#260E99',
  '#B1E4FF',
  '#7EC3E4',
  '#50A3CC',
  '#2B85B1',
  '#0E6B99',
  '#E4FFB1',
  '#C3E47E',
  '#A3CC50',
  '#85B12B',
  '#6B990E',
  '#FFD8B1',
  '#E4B17E',
  '#CC8E50',
  '#B16E2B',
  '#99540E',
  '#FFB1B1',
  '#E47E7E',
  '#CC5050',
  '#B12B2B',
  '#990E0E',
];
export const colorMaps = {
  temperatureLegendColorsWoW,
  precipitationMMLegendColorsWoW,
  temperatureLegendColorsCWK,
};
